module.exports = __webpack_public_path__ + "static/media/icon-dashboard-campaign.c6a91559.svg";